module.exports = __webpack_public_path__ + "static/media/IMG_2609.fba87e64.JPG";